import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { HeaderUnderwriting } from './HeaderUnderwriting';
import { MyQuote } from './MyQuote';
import { QuotingStepsComponent } from './QuotingStepsComponent';
import { PetSelector } from '../petSelector/PetSelector';
import {
  useOnBodyScrollEvent,
  useResponsive,
} from '../../../hooks';
import { QuotingSteps } from '../../../constants';
import figoLogo from '../../../assets/figo-logo.svg';
import { isPaycheck } from '../../../util';
import './css/Header.css';

const Header = ({ isError = false }) => {
  const { t } = useTranslation('common');
  const { isMobile, isTablet } = useResponsive();
  const store = useSelector(({ quoting }) => quoting);
  const {
    currentQuoteStep,
    isMonthlyPlan,
  } = store;

  const isFirstStep = currentQuoteStep === QuotingSteps.SelectPlan.value;
  const isSecondStep = currentQuoteStep === QuotingSteps.YourInfo.value;
  const isWelcomeStep = currentQuoteStep === QuotingSteps.Welcome.value;

  const { verticalScrollValue } = useOnBodyScrollEvent();
  const showFloating = !isMobile && !isTablet && verticalScrollValue < -5
    && !isFirstStep;

  useEffect(() => {
    // Move to top on step changed
    window.scrollTo(0, 0);
  }, [currentQuoteStep]);

  return (
    <header
      aria-label={t('header.siteHeader')}
      className={`Header ${showFloating ? 'Header-fixed' : ''}`}
      data-sticky={!isFirstStep}
      role="banner"
    >
      <HeaderUnderwriting />

      <div className="Header-content">
        <div className="Header-branding">
          <img
            alt="Figo Pet Insurance"
            className="Header-logo-image"
            src={figoLogo}
          />

          <div className="Header-price">
            {isSecondStep ? (
              <MyQuote
                isMonthlyPlan={isMonthlyPlan}
                isPaycheck={isPaycheck}
                quoteSelectedValues={store.quoteSelectedValues}
              />
            ) : null}
          </div>
        </div>

        <div className="Header-actions">
          {isError || (showFloating && isFirstStep) ? null : (
            <QuotingStepsComponent
              currentQuoteStep={currentQuoteStep}
            />
          )}

          {!isWelcomeStep ? (
            <div
              className={'Header-pet-selector-wrapper'
                + `${isSecondStep
                  ? ' Header-pet-selector-wrapper-hide' : ''}`}
            >
              <PetSelector showInteractionToAll={isSecondStep} />
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
};

export { Header };
